export const IconWaiter = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M21.167 13.63c0-4.574-3.392-8.362-7.798-9.024.187-.269.298-.593.298-.945C13.667 2.743 12.92 2 12 2c-.92 0-1.667.743-1.667 1.661 0 .352.111.676.298.945-4.406.662-7.798 4.45-7.798 9.023a.832.832 0 1 0 0 1.662h2.483c-1.048.834-1.888 1.932-2.368 3.237l-.832 2.259a.83.83 0 0 0 .495 1.066.836.836 0 0 0 1.07-.494l.832-2.258a5.85 5.85 0 0 1 5.475-3.811h3.262c.525 0 .952.426.952.95 0 .468-.351.872-.818.938l-4.3.612a.832.832 0 1 0 .235 1.645l4.3-.612c.498-.07.946-.285 1.311-.592.018-.013 3.165-2.73 3.165-2.73.335-.3.9-.265 1.188.084a.837.837 0 0 1-.066 1.168l-4.426 3.786a.83.83 0 0 0-.09 1.172c.301.348.828.387 1.176.088l4.436-3.794a2.5 2.5 0 0 0 .69-2.714h.164a.832.832 0 1 0 0-1.662m-16.667 0c0-4.123 3.365-7.477 7.5-7.477s7.5 3.354 7.5 7.476z" />
    </svg>
  );
};
